// import VueCookies from 'vue-cookies'

/**
 * webchat 多数请求需要携带token，作为用户身份的加密标识
 * 如果参数里存在openid，则默认忽略token
 * config 参数为：
 * - noToken 不携带token
 * @param service
 */
export default function autoToken(service) {
  service.interceptors.request.use(config => {
    if (!config.noToken || (config.params && config.params.openid !== undefined)) {
      if (!config.params) {
        config.params = {}
      }
      if (sessionStorage.getItem('cubeTicket') && location.href.indexOf('isiframe=1') > -1) { // iframe页面获取token
        config.params.token = JSON.parse(sessionStorage.getItem('cubeTicket')).token
      } else {
        config.params.token = sessionStorage.getItem('token')
      }
    }
    return config
  })
  return service
}



// WEBPACK FOOTER //
// ./src/utils/axios-interceptor/auto-token.js